import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import apis from "./apis";
import * as publicMethod from "./utils";
import * as staticAssets from "./utils/staticAssets";
import Union from './utils/union/setUnion';
import "./assets/css/base/reset.css";
import "./assets/css/font.css";
import 'babel-polyfill'
import SvgIcon from './components/SvgIcon/index.vue'
import * as Sentry from "@sentry/browser";
import { Vue as VueIntegration } from "@sentry/integrations";
import { Integrations } from "@sentry/tracing";

// 引入Element组件并注入到vue里
import {
  Container,
  Form,
  FormItem,
  Input,
  Message,
  Loading,
  Row,
  Col,
  Checkbox,
  Popover,
  Button,
  Table,
  TableColumn,
  Dialog,
  Select,
  Option,
  Calendar,
  ButtonGroup,
  DatePicker,
  Tooltip,
  Carousel,
  CarouselItem,
  Tabs,
  TabPane,
  Empty
} from "element-ui";
import Router from "vue-router";
import injectionWindow from './utils/lang/index';

const routerPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error => error);
};

//添加router拦截判断
router.beforeEach((to, from, next) => {
  //是否显示右边套餐对比图标
  if (to.name === "searchResult") {
    localStorage.setItem("contrast_flag", 1);
  } else {
    localStorage.setItem("contrast_flag", 2);
  }
  if (to.query.city) {
    next();
  } else {
    const { city, union } = from.query;
    to.query.city = publicMethod.getCookie("dffl_mall_city") || city || "145";

    union && (to.query.union = union);
    const pathObj = {
      path: to.path,
      query: to.query
    };
    next(pathObj);
  }
  if (to.meta.title) {
    document.body.setAttribute("data-name", `${to.meta.title}`);
  }
});

/**
 * 图片裁剪过滤器
 * @param {String} val 需要过滤的属性  ***.png
 * @param {Number} size 需要裁剪的大小  300*300
 * @return {String} 过滤后的返回值  ***.png!s300.300
 */
Vue.filter("imgCrop", function(val, size) {
  const { NODE_ENV, VUE_APP_FLAG } = process.env;
  return NODE_ENV === "production" && VUE_APP_FLAG === "pro"
    ? `${val}!s${size}.${size}`
    : val;
});

Vue.use(Container);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Input);
Vue.use(Row);
Vue.use(Col);
Vue.use(Checkbox);
Vue.use(Loading);
Vue.use(Popover);
Vue.use(Button);
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Dialog);
Vue.use(Select);
Vue.use(Option);
Vue.use(Calendar);
Vue.use(ButtonGroup);
Vue.use(DatePicker);
Vue.use(Tooltip);
Vue.use(Carousel);
Vue.use(CarouselItem);
Vue.use(Tabs);
Vue.use(TabPane);
Vue.use(Empty);

Vue.prototype.union_isBilingual = false;
Vue.prototype.$message = Message;
Vue.prototype.$origin = window.location.origin;
Vue.config.productionTip = false;
Vue.prototype.appCode = "100058";
Vue.prototype.appSecret = "sESEaXF4";
// apis
Vue.prototype.apis = apis;
// Method
Vue.prototype.publicMethod = publicMethod;
//staticAssets
Vue.prototype.staticAssets = staticAssets;
Vue.component('SvgIcon', SvgIcon); // 图标字体组件
// 工会
const union = new Union();
const unionF = publicMethod.unionFlag() || sessionStorage.getItem('dffl_union');
if (unionF && unionF !== 'null') {
  // debugger
  sessionStorage.setItem('dffl_union', unionF);
  // union.setUnionScale();
  union.findByUnion();
}

function isFeishu() { 
  var result = navigator.userAgent.toLowerCase().indexOf("lark/");
  return result >= 0 ? true : false;
}
function isDingDing() {
  var result = navigator.userAgent.toLowerCase().indexOf("dingtalk");
  return result >= 0 ? true : false;
}
function isFeishuOrDingding() {
  return isFeishu() || isDingDing();
}
Vue.prototype.isFeishuOrDingding = isFeishuOrDingding();

Vue.prototype.$bus = new Vue();

Vue.prototype.union_isBilingual = false;
injectionWindow();
Vue.prototype.TLang = window.TLang;
Vue.prototype.CheckCN = window.CheckCN;
Vue.prototype.ReplaceText = window.ReplaceText;

// 埋点
(function() {
  const { VUE_APP_FLAG } = process.env;
  const srcUrl = "//tracker.dongfangfuli.com/js/DFCollectSDK_201911061515.js";
  const apiUrl =
    VUE_APP_FLAG === "pro"
      ? "//tracker.dongfangfuli.com/tracker/add"
      : "//10.8.30.16:10012/tracker/add";
  publicMethod.loadScript(srcUrl, function() {
    try {
      let dfflSdk;
      dfflSdk = new window.DFCollectSDK({
        sendUrl: apiUrl,
        commonUpData: {
          pageName: document.body.getAttribute("data-name"),
          pageChannel: document.title
        }
      });
      setInterval(function() {
        dfflSdk.pageVisit({
          pageName: document.body.getAttribute("data-name")
        });
      }, 2000);
    } catch (error) {
      console.log(error);
    }
  });
})();

// 变态的诺和诺德工会英文字体用Verdana
if (publicMethod.unionFlag() === "aon") {
  document.body.style.fontFamily =
    "Verdana, PingFang SC, Hiragino Sans GB, Microsoft YaHei";
}

// sentry
const { NODE_ENV } = process.env;
if (NODE_ENV === "production") {
  Sentry.init({
    dsn: "https://c2836bbddd6e41139d8796a070ac3b33@sentry.dongfangfuli.com/26",
    integrations: [
      new VueIntegration({
        Vue,
        tracing: true
      }),
      new Integrations.BrowserTracing()
    ],

    // We recommend adjusting this value in production, or using tracesSampler
    // for finer control
    tracesSampleRate: 1.0
  });
}

import modules from './modules'
Vue.use(modules)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
